import React, { memo } from 'react';
import { WifiOff, Database } from 'lucide-react';
import { useFirebaseConnection } from '../../hooks/useFirebaseConnection';

interface ConnectionStatusProps {
  isOnline: boolean;
}

const ConnectionStatus: React.FC<ConnectionStatusProps> = memo(({ isOnline }) => {
  const isFirebaseConnected = useFirebaseConnection();

  // Only show when there's a connection issue
  if (isOnline && isFirebaseConnected) return null;

  return (
    <div className="fixed bottom-4 right-4 bg-yellow-50 text-yellow-800 px-4 py-2 rounded-lg shadow-lg flex items-center space-x-2 z-50">
      {!isOnline ? (
        <>
          <WifiOff className="h-5 w-5" />
          <span className="text-sm">Working offline - changes will sync when connection is restored</span>
        </>
      ) : !isFirebaseConnected ? (
        <>
          <Database className="h-5 w-5" />
          <span className="text-sm">Database connection lost - retrying...</span>
        </>
      ) : null}
    </div>
  );
});

ConnectionStatus.displayName = 'ConnectionStatus';

export default ConnectionStatus;